module.exports = __webpack_public_path__ + "static/media/0-points.faa760b6.png";